/**
 * Sestaví absolutní URL na externí mapovou aplikaci (reviewer / editor)
 * z konfigurační báze a suffixu. Vrací `null`, pokud báze chybí.
 */
export const resolveMapUrl = (base: string | null | undefined, suffix: string): string | null =>
  base ? new URL(`${base}${suffix}`, window.location.href).href : null;
